<template>
	<section class="parallax effect-section page-heading" :style="returnImage()">
		<div class="mask bg-black opacity-8"></div>
		<div class="container position-relative">
			<div class="row align-items-center justify-content-center min-vh-40">
				<div class="col-lg-8 text-center" v-if="page">
					<h1 class="display-6 text-white fw-light m-0" v-text="page" id="top"></h1>
					<ol class="breadcrumb light mb-0 mt-3 justify-content-center">
						<li class="breadcrumb-item"><router-link :to="{ name: 'Home' }">Home</router-link></li>
						<li class="breadcrumb-item" v-if="title" v-text="title"></li>
						<li class="breadcrumb-item active" v-if="page" aria-current="page" v-text="page"></li>
					</ol>
				</div>
				<div v-else>
					<h1 class="display-6 text-white m-0" id="top" v-text="Error"></h1>
				</div>
			</div>
		</div>
	</section>
</template>
<script>
export default {
	props: ['image', 'title', 'page'],
	methods: {
		returnImage() {
			return (this.image) ? `background-image: url(https://api.bs-rt.de/assets/${this.image}?key=cover); background-position: center;` : null;
		}
	},
	computed: {
		error() {
			return this.$store.state.loadingError;
		},
		loading() {
			return this.$store.state.loadingStatus;
		}
	}
};
</script>